import { useWallet } from '@web/walter-lib/stream'
import { useCommonCMSConfig } from '~api'
import { getAvailableBalance } from '~utils/data/getAvailableBalance'

export function useWalletByCurrency(currency?: string) {
    const { data: cmsData, isValidating: isConfigLoading } = useCommonCMSConfig()
    const { showLockedBalance } = cmsData?.features || {}

    const { data: wallet } = useWallet()

    const balanceData = currency ? wallet?.[currency] : {}
    const balance = getAvailableBalance({
        showLockedBalance,
        unlockedBalance: balanceData?.unlocked,
        availableBalance: balanceData?.available,
    })

    return { data: balance, isLoading: isConfigLoading }
}
